module.exports = __webpack_public_path__ + "img/tr.ed6d5f37.svg";